/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-23 16:30:56
 * @LastEditors: Andy
 * @LastEditTime: 2022-11-23 18:36:00
 */
import { defineStore as useStore } from 'pinia'
import pinia from '@main/common/pinia'

/** 二次改造 defineStore */
export const defineStore = (...args) => {
  const store = useStore(...args)
  return (p = pinia) => store(p)
}
